// extracted by mini-css-extract-plugin
export default {"forms":"CheckoutPage_forms__bJBOo"};